import React from 'react';
import '../styles/Offers.css';


const Offers = (props) => {
    console.log("offer",props.offer);
    return (
        <>
    <div className="offersSection">
       {
           props.offer.map((item,index)=>{
               return(
                   <a href={item.url}> 
                   <img src={item.image} alt={`${index} offer`}></img>
                   </a>
               )
           })
       }

    </div> 
            
        </>
    )
}

export default Offers
